var submenu = (function ( $ ) {

	var $ocm,
		$main_menu,
		$submenu_links;

	var _init = function () {
		$ocm           = $( '#off-canvas-menu' );
		$main_menu     = $ocm.find( '.nav' );
		$submenu_links = $main_menu.find( 'li.menu-item-has-children' );
		$submenu_links.each( _setup_link );
	};

	var _setup_link = function() {
		var $link = $( this ).find( 'a' ).first();

		$link.on( 'click', _click_event );
	};

	var _click_event = function( e ) {
		var $li = $( this ).closest( 'li.menu-item-has-children' ),
			$submenu = $li.find( 'ul.sub-menu' ).first();

		e.preventDefault();

		$li.toggleClass( 'open' );

		$submenu.slideToggle();
	};

	if ( $( '#off-canvas-menu' ).find( '.nav' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = submenu;